import React from "react";

import {
    Chip
} from "@mui/material";

import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import favoritIcon from "../../assets/img/Home/Products/like-icon.png";

import { formatNumber } from "../../utils/formatNumber";

const HomeProducts = ({title, description, products = []}) => {
    
    return (
        <div className="container">
            <div className="text-md-center mb-md-5 mb-4">
                <h2>{title}</h2>
                {description ?? <p>{description}</p>}
            </div>
            <div className="products-news__home">
                {products.length > 0 ? (
                    products.map((product) => (
                        <div className="card-product" key={product.id}>
                            <div className="card-product__header" style={{
                                backgroundImage: `url(${product?.images[0] ? process.env.REACT_APP_API_BASE_URL + '/uploads/' + product.images[0].url:""})`,
                            }}>
                                <button className="btn btn-favorite">
                                    <img src={favoritIcon} alt="favorite" />
                                </button>

                                <Chip className="chip-sendFree" label="Envío GRATIS" color="success" />
                            </div>
                            <div className="card-product__body">
                                <h5>{product.title}</h5>
                                <p style={{
                                    fontSize: "14px"
                                }}>
                                    <LocalShippingIcon className="pe-2" style={{color:"#4BFF8E"}} /> 
                                    Recibelo hoy o programado
                                </p>
                                <p className="card-product__price">
                                    $ {formatNumber(product.price)}
                                </p>
                            </div>
                        </div>
                    ))
                ) : (
                    <p>No products available</p>
                )}
            </div>
        </div>
    );
}

export default HomeProducts;